import React from 'react'
import styles from './FooterBar.module.css'
import { SiGooglemaps } from "react-icons/si";
import { FaFacebookF } from "react-icons/fa";
import { BiLogoTripAdvisor } from "react-icons/bi";

const FooterBar = () => {
  return (
    <footer>
        <div className={styles.barFooter}>
            <p>©2025 Hotel Torre Eiffel. Design by David</p>
            <ul className={styles.menuFooter}>
              <a href="https://facebook.com/elmejorlugarparaquedarse/" target="_blank" rel="noopener noreferrer">
                <FaFacebookF size={20} color="#2b2826" />
              </a>
              <a href="https://tripadvisor.es/Hotel_Review-g1725304-d23977667-Reviews-Hotel_Torre_Eiffel_Atacames-Atacames_Esmeraldas_Province.html" target="_blank" rel="noopener noreferrer">
                <BiLogoTripAdvisor size={26} color="#2b2826" />
              </a>
              <a href="https://google.com/travel/hotels/entity/ChkIisfZyayI0uFHGg0vZy8xMWRfOWZiMHhmEAE?q=hotel%20torre%20eiffel%20atacames&ts=CAEaIAoCGgASGhIUCgcI6Q8QAhgUEgcI6Q8QAhgVGAEyAhAAKgkKBToDVVNEGgA&ictx=3&hl=es&qs=CAAgASgASAA&ap=KigKEglZ3hfUydvrPxHfQeIxmPZTwBISCTDZ9Vzp8-s_Ed9BYk119lPAMAA&ved=0CAAQ5JsGahcKEwiAoY2X5Y6LAxUAAAAAHQAAAAAQBA" target="_blank" rel="noopener noreferrer">
                <SiGooglemaps size={20} color="#2b2826" />
              </a>
            </ul>
        </div>
    </footer>
  )
}

export default FooterBar